export interface Site {
  id: string;
  label: string;
  description: string;
  groupCount: number;
  icon: string;
  color: string;
  subjectEmail: string;
  globalAccountId: string; 
}

export const SITES: Site[] = [
  {
    id: "metal2000",
    label: "Metal 2000",
    description: "Fiches Google Business Profile — Metal",
    groupCount: 13,
    icon: "M",
    color: "#1B4FD8",
    subjectEmail: "g.noura@metal2000.fr",
    globalAccountId: "102770176164362989528", 
  },
  {
    id: "ehbs",
    label: "HBHS",
    description: "Fiches Google Business Profile — HBHS",
    groupCount: 12,
    icon: "E",
    color: "#EA7A1E",
    subjectEmail: "b.emna@hbhs.fr",
    globalAccountId: "104964969645737494428",
  },
  
  {
    id: "MGP",
    label: "MGP",
    description: "Fiches Google Business Profile — MGP ",
    groupCount: 17,
    icon: "A",
    color: "#D4590A",
    subjectEmail: "l.zayneb@metallerie-grand-paris.com",
    globalAccountId: "109266092858801549869",
  },
];